import React,{Component} from 'react'
import RectangleShape from "../types/RectangleShape";
import RenderText from "../render-text";
import {GradientDefs, GradientFillUrl} from "shape-edit/forms/fields";
import {textOverflowResizeLayer} from "app/helpers/other";
import {DEFAULT_LINE_CAP, DEFAULT_LINE_JOIN, LINE_CAP_CONSTS, LINE_JOIN_CONSTS} from "shape-edit/forms/helpers";
import { Size } from 'app/types/model-types';
import { EditModeType } from 'app/types/app-types';

interface Props {
    data: RectangleShape
    activeShapeId: string
    editMode: EditModeType
    updateShape: Function
}

interface State {
    newSize: Size
}

class RectangleSvg extends Component<Props, State> {
    constructor(props) {
        super(props)

        this.state = {
            newSize: null,
        }
    }

    setRealSize = (newSize: Size) => {
        this.setState({newSize: newSize})
    }

    render() {
        const {data} = this.props
        const scale = data.scale && data.scale !== 0 ? data.scale : 1
        const cornerRadius = data.corner_radius ?? null;
        const isShadow = data.shadow_color && data.shadow_sigma
        const fillColor = data.gradient_id && data.gradient ? GradientFillUrl(data.gradient_id) : data.color
        const fillOpacity = data.gradient_id && data.gradient && data.gradient.opacity ? data.gradient.opacity / 100 : 1

        const newSize =  textOverflowResizeLayer(data)
        const width = newSize.width || data.width
        const height = newSize.height || data.height

        const h = Math.round(data.text_fontsize/scale)

        return (
            <g className="draggable">
                {isShadow &&
                <filter id={`shadow-${data.index}`} width="200%" height="200%" y="-50%" x="-50%">
                    <feDropShadow
                        dx={data.shadow_xoffset}
                        dy={data.shadow_yoffset}
                        stdDeviation={data.shadow_sigma}
                        floodColor={data.shadow_color}
                        floodOpacity={1-data.shadow_opacity/100}
                    />
                </filter>
                }

                {data.gradient_id && data.gradient &&
                <GradientDefs gradient={data.gradient} idx={data.gradient_id} />
                }

                {cornerRadius && cornerRadius > 0 ?
                    <rect
                        transform={`translate(-${width/2},-${height/2})`}
                        width={width}
                        height={height}
                        fill={fillColor}
                        fillOpacity={fillOpacity}
                        filter={isShadow ? `url(#shadow-${data.index})` : ''}
                        strokeWidth={data.stroke_width}
                        stroke={data.stroke_color}
                        strokeLinejoin={data.line_join && LINE_JOIN_CONSTS[data.line_join] ? LINE_JOIN_CONSTS[data.line_join]: DEFAULT_LINE_JOIN}
                        strokeLinecap={data.line_cap && LINE_CAP_CONSTS[data.line_cap] ? LINE_CAP_CONSTS[data.line_cap]: DEFAULT_LINE_CAP}
                        rx={cornerRadius}
                        ry={cornerRadius}
                    />
                    :
                    <rect
                        transform={`translate(-${width / 2},-${height / 2})`}
                        width={width}
                        height={height}
                        filter={isShadow ? `url(#shadow-${data.index})` : ''}
                        fill={fillColor}
                        fillOpacity={fillOpacity}
                        strokeWidth={data.stroke_width}
                        stroke={data.stroke_color}
                        strokeLinejoin={data.line_join && LINE_JOIN_CONSTS[data.line_join] ? LINE_JOIN_CONSTS[data.line_join]: DEFAULT_LINE_JOIN}
                        strokeLinecap={data.line_cap && LINE_CAP_CONSTS[data.line_cap] ? LINE_CAP_CONSTS[data.line_cap]: DEFAULT_LINE_CAP}
                    />
                }

                <RenderText
                    shape={data}
                    fontSize={h}
                    width={width}
                    h={height}
                    setRealSize={this.setRealSize}
                    offsetY={0}
                    activeShapeId={this.props.activeShapeId}
                    updateShape={this.props.updateShape}
                    editMode={this.props.editMode}
                />
            </g>
        )
    }
}

export default RectangleSvg
